import { useAnalytics } from "../analytics/useAnalytics";

export const GoogleAnalytics = () => {
  useAnalytics();
  return null;
};
